'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Home = require('./Home.css');

var _Home2 = _interopRequireDefault(_Home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = (_dec = (0, _reactCssModules2.default)(_Home2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this, props));

    _this.state = {
      title: 'Home',
      description: _config2.default.app.description,
      url: _config2.default.domain
    };
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      var goodBadImg = require('../../../static/images/good-and-bad.jpg');
      //
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(_components.HomeHero, null),
        _react2.default.createElement('div', { id: 'h-plans' }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h2',
            { styleName: 'plan-logos-label' },
            '401(k)s and similar retirement plans'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'plan-logos-p' },
            'We\'ve rated 70+ employer-offered retirement plans for investments in fossil fuels, deforestation, weapons, private prisons, and more.'
          )
        ),
        _react2.default.createElement(_components.RetirementPlanGridTableWrap, null),
        _react2.default.createElement(
          'div',
          { styleName: 'signup-box' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'signup-box-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'signup-box-label' },
                _react2.default.createElement(
                  'h2',
                  null,
                  'Get alerted when your employer\'s plan is rated'
                )
              ),
              _react2.default.createElement(_components.SignupForm, null)
            )
          )
        ),
        _react2.default.createElement('div', { id: 'h-funds' }),
        _react2.default.createElement(
          'div',
          { styleName: 'search-box' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'search-box-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'search-box-search' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'search-box-label' },
                  _react2.default.createElement(
                    'h1',
                    null,
                    'Check if your mutual funds and ETFs are climate safe'
                  )
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_components.AutocompleteSearch, null),
                _react2.default.createElement(
                  'div',
                  { styleName: 'search-box-link' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.clean,
                      title: 'Full list'
                    },
                    'Full list',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'search-box-img' },
                _react2.default.createElement('img', {
                  src: goodBadImg,
                  alt: 'Search mutual funds'
                })
              )
            )
          )
        ),
        _react2.default.createElement('div', { id: 'h-target-dates' }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'signup-box-label-2' },
            _react2.default.createElement(
              'h2',
              null,
              'Target date fund series'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Don\'t see your company above? Check if your plan\'s default option is one of the target date fund series below.'
            ),
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(_components.TargetDateGrid, null)
        ),
        _react2.default.createElement(_components.OneTwoThree, null),
        _react2.default.createElement(_components.HomeEduCenter, null),
        _react2.default.createElement(_components.RiskTypeLinks, null),
        _react2.default.createElement(_components.IyvBanner, null),
        _react2.default.createElement(_components.HomeTestimonials, null)
      );
    }
  }]);
  return Home;
}(_react.Component)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1479
// module chunks = 0